import { BRAND_ROUNDED_STYLE_TYPES, PRIVACY_POLICY_DEFAULT_URL } from "rylak-common/src/constants";

export default function () {
    return {
        brandData: {
            fontNamePrimary: "Inter",
            displayName: "Ingrid",
            homePage: "https://www.ingrid.com/",
            fontSizePrimary: 12,
            colorPrimary: "black",
            colorSecondary: "#e0d4c5",
            orderIdPrefix: "#",
            orderIdText: "ORDER_ID",
            startBackground: "https://storage.googleapis.com/turnr-public/pexels-cottonbro-9541951.mp4",
            backgroundImage: "https://images.pexels.com/photos/9541943/pexels-photo-9541943.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
            backgroundImageOpacity: 100,
            backgroundImageBlur: 0,
            logoSrc: "/icons/ingrid/logo-ingrid-black.svg",
            logoHeight: 30,
            inputType: BRAND_ROUNDED_STYLE_TYPES.SHARP,
            checkboxType: BRAND_ROUNDED_STYLE_TYPES.SHARP,
            windowType: BRAND_ROUNDED_STYLE_TYPES.VERY_ROUNDED,
            overallType: BRAND_ROUNDED_STYLE_TYPES.SHARP,
            buttonType: BRAND_ROUNDED_STYLE_TYPES.SHARP,
            productsBundleMock: "DEMO_BRAND",
            exchangeActive: true,
            privacyPolicyUrl: PRIVACY_POLICY_DEFAULT_URL,
            termsAndConditionsUrl: "",
        },
        brandName: "demo-brand",
    };
}
